import { defineMessages } from 'react-intl-next';

export const i18n: {
    assignee: {
        defaultMessage: string;
        description: string;
        id: string;
    }; jiraFilterAssigneeLabelSelected: {
        defaultMessage: string;
        description: string;
        id: string;
    }; jiraFilterAssigneeLabelUnselected: {
        defaultMessage: string;
        description: string;
        id: string;
    }; jiraFilterContributorPlaceholder: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	assignee: {
		id: 'dynamic-cards-search-page.filters.names.assignee',
		defaultMessage: 'Assignee',
		description: 'Label for filtering by assignee',
	},
	jiraFilterContributorPlaceholder: {
		id: 'dynamic-cards-search-page.jira.filter.assignee.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for assignee filter search input',
	},
	jiraFilterAssigneeLabelSelected: {
		id: 'dynamic-cards-search-page.jira.filter.assignee.selected',
		defaultMessage: 'Selected',
		description: 'Jira assignee filter selected label',
	},
	jiraFilterAssigneeLabelUnselected: {
		id: 'dynamic-cards-search-page.jira.filter.assignee.unselected',
		defaultMessage: 'Suggested',
		description: 'Jira assignee filter unselected label',
	},
});
